import { registerPlugin } from '@capacitor/core';
import { ClipboardWeb } from './web';
var Clipboard = registerPlugin('Clipboard', {
  web: function web() {
    return new ClipboardWeb();
  }
});
export * from './definitions';
export { Clipboard };